import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import css from "./AdminPage.module.css";

import { Input } from "../../components/common/Input";
import { DataContext } from "../../context/DataContext";
import { createActsListFirebase } from "../../services/firebaseService";
import OutsideAlerter from "../../utils/OutsideAlerter";
import { Head } from "../../utils/Head";

export const AdminValues = () => {
  const { valuesList, setValuesList } = useContext(DataContext);
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showPost, setShowPost] = useState(false);

  function deletePost(post) {
    let updatedValues = [...valuesList];
    updatedValues = updatedValues.filter((p) => p.id !== post.id);

    setValuesList(updatedValues);
    createActsListFirebase("values", updatedValues);
    alert(post.title + " deleted");
  }

  return (
    <div className={css.container}>
      <Head title="Admin" description={"Admin - Ibhava"} />
      <Input
        type="text"
        name="Buscar"
        placeholder="Title"
        label="Search"
        className={css.inputText}
        autoComplete="off"
      />
      <h5>Lista de values</h5>
      {valuesList.map((post) => (
        <div className={css.card} key={post.id}>
          <div className={css.cardTop}>
            <i
              className={`material-icons materialIcon`}
              onClick={() =>
                navigate("/admin/editact", {
                  state: {
                    axis: post.axis,
                    id: post?.id || "",
                    createdAt: post?.createdAt || "",
                    updatedAt: post?.updatedAt || "",
                    image: post?.image || "",
                    title: post?.title || "",
                    url: post?.url || "",
                    content: post?.content || "",
                  },
                })
              }
            >
              edit
            </i>
            <i
              className={`material-icons materialIcon`}
              onClick={() => setShowDeleteModal(post)}
            >
              delete
            </i>
          </div>
          <div className={css.cardBody} onClick={() => setShowPost(post)}>
            <p>{post.title}</p>
          </div>
        </div>
      ))}

      {showPost && (
        <OutsideAlerter setMenuButton={setShowPost}>
          <div className={css.modal}>
            <header className={css.modalHeader}>
              <span
                onClick={() => setShowPost(false)}
                className={`material-icons ${css.materialIcon} ${css.materialButton}`}
              >
                close
              </span>
            </header>
            <div className={css.modalBody}>
              <h3>{showPost.title}</h3>
              <p>{showPost.content}</p>
            </div>
          </div>
        </OutsideAlerter>
      )}
      {showDeleteModal && (
        <OutsideAlerter setMenuButton={setShowDeleteModal}>
          <div className={css.modal}>
            <header className={css.modalHeader}>
              <span
                onClick={() => setShowDeleteModal(false)}
                className={`material-icons ${css.materialIcon} ${css.materialButton}`}
              >
                close
              </span>
            </header>
            <div className={css.modalBody}>
              <h3>Delete {showDeleteModal.title}?</h3>
              <button
                className="deleteButton"
                onClick={(e) => {
                  e.preventDefault();
                  deletePost(showDeleteModal);
                  setShowDeleteModal(false);
                }}
              >
                Deletar
              </button>
            </div>
          </div>
        </OutsideAlerter>
      )}
    </div>
  );
};
